/**
 * Public Firebase web config (not secrets: Firebase web keys are meant to ship to the browser).
 * Shared by the page and the service worker. Null until every variable is set — the whole push
 * opt-in UI stays hidden and nothing Firebase-related loads (README: "Notificações push").
 */
const env = import.meta.env;

export const firebaseConfig =
  env.VITE_FIREBASE_API_KEY && env.VITE_FIREBASE_PROJECT_ID && env.VITE_FIREBASE_MESSAGING_SENDER_ID && env.VITE_FIREBASE_APP_ID
    ? {
        apiKey: env.VITE_FIREBASE_API_KEY,
        projectId: env.VITE_FIREBASE_PROJECT_ID,
        messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
        appId: env.VITE_FIREBASE_APP_ID,
      }
    : null;

export const firebaseVapidKey: string | undefined = env.VITE_FIREBASE_VAPID_KEY || undefined;

export const isPushConfigured = Boolean(firebaseConfig && firebaseVapidKey);
